import { Component, EventEmitter, Injector, Input, Output, ViewChild } from '@angular/core';
import { FormlyView } from '../../../ui/Data/FormlyView';
import { ListView } from '../../../ui/Data/ListView';

import { FormlyDetailedViewComponent } from '../../formly-detailed-view/formly-detailed-view.component';
import { Art57Node } from '../../../ui/Node/Art57Node/Art57Node';
import { TreeNodeDrugIngredient } from '../../../ui/Node/Art57Node/Entity/TreeNodeDrugIngredient';
import { XevprmSubmissionService } from '../../../service/xevprm-submission-service/xevprm-submission.service';

@Component({
  selector: 'app-detailed-create-send-product-report-view',
  templateUrl: './detailed-create-send-product-report-view.component.html',
  styleUrl: './detailed-create-send-product-report-view.component.scss'
})
export class DetailedCreatedSendProductReportViewComponent {
  @Input() selectedNode: any;
  @Input() fieldsErrorsControl: any;
  @Output() modelChange = new EventEmitter<any>();
  @Output() goToSelectedNode = new EventEmitter<any>();
  @Output() buttonAction = new EventEmitter<any>();
  @Output() removeNode = new EventEmitter<any>();
  @ViewChild('formly_detailed_view_component') formly_detailed_view_component!: FormlyDetailedViewComponent; 

  public sendMessageLoading$ = this.injector.get(XevprmSubmissionService).loading; // Expose loading observable for template via async pipe
  
  constructor(public injector: Injector) {}

  onFormlyDetailedModelChange(event: any) {

    this.modelChange.emit(event);
  }

    onListDetailedModelChange(event: any) {
      this.modelChange.emit(event);
    } 

  isInstanceOfFormlyDrugIngredientsFormlyView(): boolean {
    return (this.selectedNode instanceof TreeNodeDrugIngredient);
  }

  isInstanceOfFormlyView(): boolean {
    return (this.selectedNode.data instanceof FormlyView) && (!this.isInstanceOfFormlyDrugIngredientsFormlyView());
  }

  isInstanceOfListView(): boolean {
    return this.selectedNode.data instanceof ListView;
  }

 onButtonAction(event: any){
  this.buttonAction.emit(event);
 }

 onSelectedNodeChange(selectedNode:Art57Node){
  this.goToSelectedNode.emit(selectedNode);
 }

 onRemoveNode(selectedNode: Art57Node) {
  this.removeNode.emit(selectedNode);
 }
}
